import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    decimals: { type: Number, default: 0 }
  }

  connect() {
    // Format on initial load
    this.formatValue();

    // Add event listeners
    this.element.addEventListener('focus', this.handleFocus.bind(this));
    this.element.addEventListener('blur', this.handleBlur.bind(this));
  }

  disconnect() {
    // Clean up event listeners
    this.element.removeEventListener('focus', this.handleFocus.bind(this));
    this.element.removeEventListener('blur', this.handleBlur.bind(this));
  }

  handleFocus(event) {
    // Remove commas when user focuses to make editing easier
    const value = this.element.value;
    if (value) {
      this.element.value = value.replace(/,/g, '');
    }
  }

  handleBlur(event) {
    // Add commas back when user leaves the field
    this.formatValue();
  }

  formatValue() {
    const value = this.element.value;

    if (value && value !== '') {
      // Remove any existing commas first
      const cleanValue = value.replace(/,/g, '');
      const numValue = parseFloat(cleanValue);

      if (!isNaN(numValue)) {
        // Format with commas
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: this.decimalsValue,
          maximumFractionDigits: this.decimalsValue
        });

        // Update the input field value with commas
        this.element.value = formattedValue;
      }
    }
  }
}